import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

Vue.use(Vuex);
export default function createStore(env) {
  return new Vuex.Store({
    actions,
    mutations,
    getters,
    state() {
      return {
        _env: env,
        _modals: [],
        _menus: [],
        _overlays: {
          searchOverlay: false,
          mobileSearchOverlay: false,
          categoriesOverlay: false,
        },
        _status: {
          // Статусы заказа
          CODE_ORDER_SUCCESS: 2, // оплачено обработка заказа
          CODE_ORDER_CANCELED: 3, // отмена заказа
          CODE_ORDER_IN_DELIVERY: 6, // в пути
          CODE_ORDER_DELIVERED: 7, // доставлено
        },
        _types: {
          // способы доставки
          PICKUP: 1, // Самовывоз
          COURIER_DELIVERY: 2, // Курьерская доставка
          EXPRESS_DELIVERY: 3, // Экспресс доставка
          POST_DELIVERY: 4, // Почта России (скрыта)
          CDEK_DELIVERY: 5, // CDEK доставка
          CUSTOM_DELIVERY: 6, // Свой вариант доставки
          // способы оплаты
          ONLINE_CARD_PAY: 1, // Оплата картой онлайн
          OFFLINE_CARD_PAY: 2, // Картой при получении
          OFFLINE_CASH_PAY: 3, // Наличными при получении
          // коды полов
          MALE: 1,
          FEMALE: 2,
          UNKNOWN_GENDER: 3,
          // беременна или родитель
          CODE_PREGNANT: 1,
          CODE_PARENT: 2,
          // коды контактных данных
          PHONE: 1,
          ADDRESS: 2,
          SOCIAL: 3,
          EMAIL: 4,
        },
        variables: {}, // данные для фильтра
        all_brands: [], // все бренды в выпадающем списке в хедере
        popular_brands: [], // популярные бренды
        categories: [],
        marketplace: {},
        baby_shops: [],
        auth: {
          user: null,
          cart: [], // товары в корзине
          orders: [], // все заказы, чтобы подсчитать сумму
          orders_paginate: {}, // заказы в лк
          deliveries: [], // способы доставки
          favorites: [], // все избранные, чтобы вывести в хедере
          favorites_objects: [], // все избранные, в виде объектов
          favorites_paginate: {}, // избранные в лк
          addresses: [], // адреса доставки
        },
        home_page: {
          main_categories: [],
          banner_shares: [],
          popular_products: [],
          main_brand: {},
          news: [],
          banners: [],
        },
        product_page: {
          product: {},
        },
        catalog_page: {
          products: {},
          category: {},
          filter_attributes: [],
          brand: {},
        },
        shares_page: {
          shares: {},
        },
        news_page: {
          news: {},
        },
        news_item_page: {
          news_item: {},
          read_also_news: [],
        },
        school_page: {
          school: {},
          courses: [],
        },
        shop_page: {
          shops: [],
          shop_item: [],
        },
      };
    },
  });
}
